import { connect } from 'react-redux';
import FinanceListing from "./FinanceListing";
import { bindActionCreators } from 'redux';
import { getCampaignData } from 'services/redux/brandActivtion/adsCampaign/action';

const mapStateToProps = state => ({
    getCampaignListing: state.campaignReducer.getCampaignListing,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getCampaignData
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(FinanceListing);
